var _path, _path2, _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTrashSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.123 20.131L19.148 4.5H4.852l1.025 15.631A2 2 0 007.873 22h8.254a2 2 0 001.996-1.869zM3.5 4.5h17",
    stroke: "#213555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 4.742v-2a1 1 0 00-1-1h-6.5a1 1 0 00-1 1v2",
    stroke: "#213555"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.25,
    y: 7.907,
    width: 1,
    height: 11.111,
    rx: 0.5,
    fill: "#213555"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 7.907,
    width: 1,
    height: 11.111,
    rx: 0.5,
    fill: "#213555"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xOC4xMjI3IDIwLjEzMUwxOS4xNDg0IDQuNUg0Ljg1MTU2TDUuODc3MzQgMjAuMTMxQzUuOTQ2MzUgMjEuMTgyNCA2LjgxOTMyIDIyIDcuODczMDUgMjJIMTYuMTI2OUMxNy4xODA3IDIyIDE4LjA1MzcgMjEuMTgyNCAxOC4xMjI3IDIwLjEzMVoiIHN0cm9rZT0iIzIxMzU1NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8bGluZSB4MT0iMy41IiB5MT0iNC41IiB4Mj0iMjAuNSIgeTI9IjQuNSIgc3Ryb2tlPSIjMjEzNTU1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjxwYXRoIGQ9Ik0xNi4yNSA0Ljc0MTkxVjIuNzQxOTFDMTYuMjUgMi4xODk2MiAxNS44MDIzIDEuNzQxOTEgMTUuMjUgMS43NDE5MUg4Ljc1QzguMTk3NzIgMS43NDE5MSA3Ljc1IDIuMTg5NjIgNy43NSAyLjc0MTkxVjQuNzQxOTEiIHN0cm9rZT0iIzIxMzU1NSIvPg0KPHJlY3QgeD0iOS4yNSIgeT0iNy45MDczIiB3aWR0aD0iMSIgaGVpZ2h0PSIxMS4xMTExIiByeD0iMC41IiBmaWxsPSIjMjEzNTU1Ii8+DQo8cmVjdCB4PSIxMy43NSIgeT0iNy45MDcyOSIgd2lkdGg9IjEiIGhlaWdodD0iMTEuMTExMSIgcng9IjAuNSIgZmlsbD0iIzIxMzU1NSIvPg0KPC9zdmc+DQo=";
export { SvgIconTrashSmall as ReactComponent };